console.log('🚀 [ComplaintForm.jsx] Ładowanie ComplaintForm');

import React, { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { api } from '../utils/api';
import { useToast } from '../context/ToastContext';

console.log('✅ [ComplaintForm.jsx] Importy załadowane');

function ComplaintForm() {
  console.log('🎨 [ComplaintForm.jsx] Renderowanie ComplaintForm');
  const [formData, setFormData] = useState({
    reported_discord_id: '',
    reported_display: '',
    description: '',
    evidence_links: ''
  });
  
  const [errors, setErrors] = useState({});
  const [submitting, setSubmitting] = useState(false);
  const navigate = useNavigate();
  const { unit } = useParams();
  const base = `/${unit}`;
  const { success, error } = useToast();
  
  
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
    
    // Clear error when user starts typing
    if (errors[name]) {
      setErrors(prev => ({ ...prev, [name]: null }));
    }
  };
  
  const validate = () => {
    const newErrors = {};
    
    if (!formData.reported_discord_id.trim()) {
      newErrors.reported_discord_id = 'Wymagane pole';
    } else if (!/^\d{17,19}$/.test(formData.reported_discord_id)) {
      newErrors.reported_discord_id = 'Nieprawidłowy format Discord ID (17-19 cyfr)';
    }
    
    if (!formData.reported_display.trim()) {
      newErrors.reported_display = 'Wymagane pole';
    }
    
    if (formData.description.length < 50) {
      newErrors.description = `Wymagane minimum 50 znaków (obecnie: ${formData.description.length})`;
    }
    
    return newErrors;
  };
  
  const handleSubmit = async (e) => {
    e.preventDefault();
    
    const newErrors = validate();
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }
    
    setSubmitting(true);
    
    try {
      // Parse evidence links (one per line)
      const evidence_links = formData.evidence_links
        .split('\n')
        .map(link => link.trim())
        .filter(link => link.length > 0);
      
      const payload = {
        reported_discord_id: formData.reported_discord_id,
        reported_display: formData.reported_display,
        description: formData.description,
        evidence_links,
        unit
      };
      
      await api.post('/post-complaint', payload);
      success('Skarga została wysłana! Wkrótce zostanie utworzony ticket na Discord.');
      navigate(`${base}/dashboard`);
    } catch (err) {
      console.error('Failed to submit complaint:', err);
      error(err.message || 'Nie udało się wysłać skargi');
    } finally {
      setSubmitting(false);
    }
  };
  
  return (
    <div className="form-page">
      <div className="form-container">
        <header className="form-header">
          <h1>⚠️ Formularz Skargi</h1>
          <button onClick={() => navigate(`${base}/dashboard`)} className="btn-secondary">
            ← Powrót
          </button>
        </header>
        
        <div className="alert alert-info">
          <p>Skarga dotyczy członków Military Police. Zostanie rozpatrzona przez zarząd Wydziału.</p>
        </div>
        
        <form onSubmit={handleSubmit} className="complaint-form">
          <div className="form-group">
            <label htmlFor="reported_discord_id">Discord ID zgłaszanej osoby *</label>
            <input
              type="text"
              id="reported_discord_id"
              name="reported_discord_id"
              value={formData.reported_discord_id}
              onChange={handleChange}
              placeholder="np. 123456789012345678"
              className={errors.reported_discord_id ? 'error' : ''}
            />
            {errors.reported_discord_id && <span className="error-message">{errors.reported_discord_id}</span>}
            <small>Aby skopiować Discord ID: Ustawienia → Zaawansowane → Tryb Dewelopera → Kliknij prawym na użytkownika → Skopiuj ID</small>
          </div>
          
          <div className="form-group">
            <label htmlFor="reported_display">Imię i nazwisko / Nick zgłaszanej osoby *</label>
            <input
              type="text"
              id="reported_display"
              name="reported_display"
              value={formData.reported_display}
              onChange={handleChange}
              placeholder="np. Jan Kowalski lub NickDiscord#1234"
              className={errors.reported_display ? 'error' : ''}
            />
            {errors.reported_display && <span className="error-message">{errors.reported_display}</span>}
          </div>
          
          <div className="form-group">
            <label htmlFor="description">
              Opis skargi (min. 50 znaków) *
              <span className="char-count">{formData.description.length}/50</span>
            </label>
            <textarea
              id="description"
              name="description"
              value={formData.description}
              onChange={handleChange}
              rows="8"
              placeholder="Szczegółowo opisz sytuację, która miała miejsce..."
              className={errors.description ? 'error' : ''}
            />
            {errors.description && <span className="error-message">{errors.description}</span>}
          </div>
          
          <div className="form-group">
            <label htmlFor="evidence_links">Linki do dowodów (opcjonalne)</label>
            <textarea
              id="evidence_links"
              name="evidence_links"
              value={formData.evidence_links}
              onChange={handleChange}
              rows="4"
              placeholder="Wklej linki do zrzutów ekranu, nagrań itp. (jeden link w linii)"
            />
            <small>Każdy link w osobnej linii. Obsługiwane: zrzuty ekranu, nagrania, logi czatu.</small>
          </div>
          
          <button 
            type="submit" 
            className="btn-primary" 
            disabled={submitting}
          >
            {submitting ? 'Wysyłanie...' : 'Wyślij Skargę'}
          </button>
        </form>
      </div>
    </div>
  );
}

export default ComplaintForm;
